export class Data {

    constructor(pieceValue, ownerValue, selected) {
        this.pieceValue = pieceValue;
        this.ownerValue = ownerValue;
        this.selected = selected;
    }

}

